import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for processes UI state.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    closeSlideout: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({
        ...state,
        isSlideoutOpen: false,
      }),
    }),
    openSlideout: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({
        ...state,
        isSlideoutOpen: true,
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
